// extracted by mini-css-extract-plugin
export var buttons = "bF_cr";
export var left = "bF_bS";
export var media = "bF_gS";
export var right = "bF_bV";
export var section = "bF_b";
export var selected = "bF_bg";
export var signature = "bF_gR";
export var testimonial = "bF_gQ";
export var text = "bF_cn";
export var textContainer = "bF_bZ";
export var video = "bF_gT";